<script setup lang="ts">
  import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
  } from "@/components/ui/card"
  import { Skeleton } from "@/components/ui/skeleton"
</script>

<template>
  <Card data-testid="your-usage-card-skeleton">
    <CardHeader>
      <CardTitle>Energy Usage</CardTitle>
    </CardHeader>
    <CardContent>
      <div class="space-y-0.5">
        <Skeleton class="h-[24px] w-[250px] sm:h-[28px]" />
        <Skeleton class="h-[24px] w-[150px] sm:h-[28px]" />
        <Skeleton class="h-[24px] w-[150px] sm:h-[28px]" />
      </div>
      <div class="my-4 flex">
        <div class="w-full">
          <div class="space-y-0.5">
            <Skeleton class="h-[24px] w-[140px] sm:h-[26px]" />
            <Skeleton class="h-[24px] w-[140px] sm:h-[26px]" />
            <Skeleton class="h-[24px] w-[140px] sm:h-[26px]" />
          </div>
        </div>
        <div class="w-full">
          <div class="space-y-0.5">
            <Skeleton class="h-[24px] w-[140px] sm:h-[26px]" />
            <Skeleton class="h-[24px] w-[140px] sm:h-[26px]" />
            <Skeleton class="h-[24px] w-[140px] sm:h-[26px]" />
          </div>
        </div>
      </div>
      <Skeleton class="h-[24px] w-full sm:h-[28px]" />
    </CardContent>
    <CardFooter>
      <Skeleton class="h-[36px] w-full sm:w-[171px]" variant="rounded" />
    </CardFooter>
  </Card>
</template>
